import * as React from "react";
import * as utils from "../utils";
import PercentageLabel from "./PercentageLabel";
import {Button, Glyphicon} from "react-bootstrap";

export default class TaskTable extends React.Component{

    constructor(){
        super();

        this.state = {
            showTeam: false,
        }
    }

    showTeam(event){
        this.setState({showTeam: event.target.checked})
    }

    render(){

        let {tasks, project} = this.props;
        tasks.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))

        return (<table className="table table-striped entry-table">
            <thead>
            <tr>
                <th style={{width: 300}}>Task</th>
                <th>Budget</th>
                <th>Hours</th>
                <th />
                <th />
            </tr>
            </thead>
            <tbody>
            {tasks.length > 0 ?
                tasks.map((task, id) => {
                    return <tr key={task.id} onClick={() => this.props.onItemClick(task)} className="hoverable">
                        <td>{task.name}</td>
                        <td className="budget">{utils.formatHours(task.budgetMinutes)}</td>
                        <td>{utils.formatHours(task.minutesTotal)}</td>
                        <td>{!!task.budgetMinutes && (<PercentageLabel a={task.minutesTotal} b={task.budgetMinutes} minutes={true} label="Task" showPercentage />)}</td>
                        <td>
                            <Button onClick={(e) => this.props.toReportingClick(e, task)} className="pull-right">
                                <Glyphicon glyph="list"/>&nbsp;
                                Show entries
                            </Button>
                        </td>
                    </tr>
                }) : (
                    <tr>
                        <td colSpan={5}><em>No tasks found.</em></td>
                    </tr>
                )}
            </tbody>
            <tfoot className="entry-table-footer">
                <tr>
                    <td>Total</td>
                    <td>{utils.formatHours(project.budgetMinutesTotal)}</td>
                    <td>{utils.formatHours(project.minutesTotal)}</td>
                    <th />
                </tr>
            </tfoot>
        </table>);
    }
}


// WEBPACK FOOTER //
// ./src/components/TaskTable.js